import { useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getAllBacteriumCount,CreateBacteriumCount,UpdateBacteriumCount,DeleteBacteriumCount} from '../../services/micro/micro'

export const useBacteriumCountText = () => {

    const [createSweet] = useSweetAlert();
    const [listBacteriumCount, setListBacteriumCount] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchListBacteriumCount, setSearchListBacteriumCount] = useState([])

    // ? MODAL CRUD
    const [modal, setModal] = useState(false)
    const [tittle, setTittle] = useState("")
    const [method, setMethod] = useState("")
    const [id_resistance, setId_resistance] = useState(0);
    const [titleDelete, setTitleDelete] = useState("")
    

     // ? Alert Modal
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    // ? search 
    const [searchBacteriumCountText, setSearchBacteriumCountText] = useState("");
    const [loadingExport, setLoadingExport] = useState(false);

    // * FORM 
    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name:"",
    });

    const {
        name,
    } = formValues;
   
    useEffect(() => {
        getBacteriumCount()
    }, []);
    
    const getBacteriumCount = async (_type) =>
        {
            const resistance = await getAllBacteriumCount();    

            if (resistance?.length > 0)
            {
                let startItems = 0;
                let endItems = numberItems;
                let aux = numberItems * currentPage;
                let _new_list = [];

                endItems = aux;
                startItems = endItems - numberItems;

                resistance.forEach((_find,_key) => {
                    let posicion = _key + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }
                    _new_list.push({
                        id_bacterium_count_text: _find?.id_bacterium_count_text ?? null,
                        name: _find?.name ?? null,
                        visibleTable: visibleTable,
                    })
                });
                setListBacteriumCount(_new_list);      
                setSearchListBacteriumCount(_new_list)              
            }
    }


    const openDialogB = (title, mode) => {
        setTittle(title);
        setMethod(mode);
        setModal(true);
    };
    const closeDialogB = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);
        setShowDeleteAlert(false);
    };


    // * CRUD TABLE
    const handleCreate = () => 
    {        
        handleUpdateValues({
            name:"",
        })
        setTittle("Crear Bacteria")
        setMethod("create")
        openDialogB("Crear interpretación cuantitativa", "create");
    }

    const saveCreate =async (e) => 
    {
        e.preventDefault();
        
        setLoading(true);
        const response = await CreateBacteriumCount({
            name: formValues.name,  
        });

        if (response.code === 200){
            setLoading(false);
            getBacteriumCount()
            createSweet("success", "success", "Se a creado correctamente");
            closeDialogB();
            handleUpdateValues({
                name:"",
            })
        } 
    }

    const handleUpdate = (id_bacterium_count_text) => 
    {
        let list = listBacteriumCount.find(c => c.id_bacterium_count_text === parseInt(id_bacterium_count_text));

        if (list !== "" || list !== null) {

            handleUpdateValues({
                name: list?.name,
            });
            setTittle("Actualizar")
            setId_resistance(id_bacterium_count_text)
            setMethod("update")
            openDialogB("Editar interpretación cuantitativa", "update");
        }
    }

    const saveUpdateBacterium = async (e) => 
    {
        e.preventDefault();
        setLoading(true);

        const response = await UpdateBacteriumCount({
            id_bacterium_count_text: id_resistance,
            name: formValues.name,   
        });

        if (response.code === 200){
                setLoading(false);
                createSweet("success", "success", "Se a actualizado correctamente");
                getBacteriumCount()
                closeDialogB();
            handleUpdateValues({
                name:"",
            })
            setId_resistance(0);
        } 
    }

    const handleDelete = (id_bacterium_count_text,_name) => 
    {
        let list = listBacteriumCount.find(c => c.id_bacterium_count_text === parseInt(id_bacterium_count_text));

        if (list !== "" || list !== null) {

            handleUpdateValues({
                name: list.name,
            });
            setTitleDelete(list.name)
            setId_resistance(id_bacterium_count_text)
            setMethod("delete")
            openDeleteAlert();
        }
    }

    const saveDeleteBacterium= async (e) => 
    {
        e.preventDefault();
    
        setLoading(true);
    
        const response = await DeleteBacteriumCount({
            id_bacterium_count_text : id_resistance
        });
    
        if (response.code === 200){
            setLoading(false);
            createSweet("success", "success", "Se a eliminado correctamente");
            closeDeleteAlert()
            getBacteriumCount()
            handleUpdateValues({
                name:"",
            })
            setId_resistance(0);
        } 
    }

    // ? PAGINATION 
    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(listBacteriumCount.length, numberItems);

    useEffect(() => {

        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;

        let listcompanies = [];
        listBacteriumCount.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listcompanies.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setListBacteriumCount(listcompanies);

    }, [totalPageCount, currentPage]);
   
    // ? SEARCH TYPE DISCOUNT
    const handleSearchBacteriumC = (e) => {
        searchBacteriumCountText(e);

        let busqueda = e.toUpperCase;
        let newMethod = [];

        searchListBacteriumCount.forEach(element => {

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setListBacteriumCount(newMethod);
    }

    
    const handleClearBacteriumCountText = () => {
        setSearchBacteriumCountText("");                         
        localStorage.removeItem("globalFilter");    
        setListBacteriumCount(searchListBacteriumCount);                    
    };

      const handleExportExcelBacteriumCountText = async () => {
        setLoadingExport(true);
        try {
            const XLSX = await import("xlsx");

          const _report = listBacteriumCount.map((item, index) => ({
                "#": index + 1,
                Interpretación: item.name ?? "---",
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Interpretaciones Cuantitativas");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catalogo_interpretación_cuantitativa.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };


    return {
        // * LIST
        listBacteriumCount,

        //* CRUD TABLE
        handleCreate,handleUpdate,handleDelete,method,modal,tittle,
        name,handleInputChange,titleDelete,
        saveCreate,saveUpdateBacterium,saveDeleteBacterium,loading,handleExportExcelBacteriumCountText, 

          //* SEARCH
        handleSearchBacteriumC, handleClearBacteriumCountText, searchBacteriumCountText, loadingExport, 

        //*DIALOG
        closeDeleteAlert, closeDialogB,
        showDeleteAlert, modalAlert, 
    }
}
